export default {
  'YouTube and High Definition Videos': '유튜브 및 고화질 비디오',
  'Story videos (Instagram/Snaps/TikTok)': '스토리 비디오 (인스타그램/스냅스/틱톡)',
  'Facebook and Instagram Feed videos': '페이스북과 인스타그램 피드 비디오',
  'Facebook and Twitter Portrait Videos': '페이스북과  트워터  초상화 비디오',
  'Twitter and Facebbok Landscape Videos': '트워터 및 페이스북 풍경 비디오',
  'Facebook Cover Videos And Blog Banners': '페이스북 커버 비디오 및 블로그 배너',
  'Fit': '적응하기',
  'Fill': '채우기',
}